
import { Variant, debugActive } from "./Variant.js";

export const tokenKey = debugActive ? "oidc.user:https://app.inventory-one.com/auth/realms/development:inventory-one-development" : ((Variant.tag === 0) ? "oidc.user:https://app.meinwerkzeugkoffer.de/auth/realms/mein-werkzeugkoffer:mein-werkzeugkoffer-browser" : "oidc.user:https://app.inventory-one.com/auth/realms/inventory-one:inventory-one-browser");

